import { render } from "./AgendaMain.vue?vue&type=template&id=0bacb5de&scoped=true"
import script from "./AgendaMain.vue?vue&type=script&lang=js"
export * from "./AgendaMain.vue?vue&type=script&lang=js"

import "./AgendaMain.vue?vue&type=style&index=0&id=0bacb5de&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bacb5de"]])

export default __exports__